import {Invoice} from './_models'

const REFERENCED_INVOICE_ACTIONS = [2, 3, 4]

export const getReferencedInvoiceMinimumDate = (
  invoice: Invoice | null | undefined,
  action: number | undefined
) => {
  if (!invoice) {
    return undefined
  }

  if (action && REFERENCED_INVOICE_ACTIONS.includes(action)) {
    return invoice.idt
  }

  return (invoice.sbji || 1) !== 1 ? invoice.ridt : undefined
}

export const REFERENCED_INVOICE_DATE_HINT =
  'تاریخ و ساعت صورتحساب ارجاعی نمی‌تواند قبل از تاریخ و ساعت صورتحساب اصلی باشد.'
